<template>
  <div class="sph">
    <router-view>

    </router-view>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.sph {
  font-family: Noto Sans SC-Medium, Noto Sans SC;
  height: 100vh;
  overflow: scroll;
}
</style>

<style lang="scss">
.sph-survey-header {
  color: #fff;

  h2 {
    font-family: Johnston100W03-Medium-Regular, Johnston100-W03-Medium;
    font-weight: 400;
    font-size: 28px;
    margin: 0;
    margin-bottom: 10px;
  }
  h3 {
    font-weight: 500;
    font-size: 16px;
    margin: 0;
    //   font-family: Noto Sans CJK SC-Medium, Noto Sans SC;
  }
}
</style>